module.exports = __webpack_public_path__ + "img/campaign-phone.6ca8e55d.png";